export default __webpack_public_path__ + "static/media/m-bottom-bg.5d669b74.png";